import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { errorHandler } from 'api/axios_instance';
import { CreateProjectRequest, QueryKey } from 'api/model.ts';
import { createProject, getProjects } from 'api/projects/requests';
import { toast } from 'react-toastify';

const queryKey = QueryKey.Projects;

const useProjects = () => {
  const queryClient = useQueryClient();

  const { data: projects, isLoading } = useQuery({
    queryKey: [queryKey],
    queryFn: () => getProjects({ pageParam: 1, pageSize: 100 }),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  const create = useMutation({
    mutationFn: (project: CreateProjectRequest) => createProject(project),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [queryKey] });
      toast.success('Project successfully created');
    },
    onError: errorHandler('Creating project failed'),
  });

  const clearQueryKey = () => {
    void queryClient.invalidateQueries({ queryKey: [queryKey] });
  };

  return { projects, isLoading, create, clearQueryKey };
};

export { queryKey };
export default useProjects;
